import type { UserInfo } from '@ixigo-packages/login/react';

/** The signed-in user's name: the one they set, else first and last name;
 *  empty when there's neither. */
export function userFullName(user: UserInfo | null): string {
	if (!user) return '';
	return (
		user.name?.trim() ||
		[user.firstName, user.lastName].filter(Boolean).join(' ')
	);
}
